import { render, staticRenderFns } from "./DashboardOptions.vue?vue&type=template&id=0237fbe8&scoped=true&"
import script from "./DashboardOptions.vue?vue&type=script&lang=js&"
export * from "./DashboardOptions.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOptions.vue?vue&type=style&index=0&id=0237fbe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0237fbe8",
  null
  
)

export default component.exports